import { validateOrderTripAddition } from '.'

import { isOrderUpcomingOrCurrent } from 'lib/order/isUpcoming'
import { sortOrdersByDeparture } from 'lib/order/orderUtils'

export function getFutureFilteredOrdersForChat(
  orders: Array<App.Order> = [],
): Array<App.Order> {
  return sortOrdersByDeparture(
    orders.filter(
      (order) =>
        isOrderUpcomingOrCurrent(order) &&
        validateOrderTripAddition(order),
    ),
  )
}
